import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import Sidebar from "../../../partials/aside/Sidebar";
import httpService from "../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../helpers/spinner";
import helpersNumbers from "../../../../helpers/numbers";
import helpersTime from "../../../../helpers/time";
import statusDiscount from "./status-discount";

function AllDiscount() {
  const [discounts, setDiscounts] = useState([]);
  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  useEffect(() => {
    getAllDiscounts();
  }, []);

  const getAllDiscounts = async () => {
    const resultSendRequestGetAllDiscounts = await sendRequestGetAllDiscounts();
    if (!resultSendRequestGetAllDiscounts) {
      return;
    }
    setDiscounts(resultSendRequestGetAllDiscounts.reverse());
  };

  const sendRequestGetAllDiscounts = async () => {
    let headersRequest = getHeaderForRequest();
    let resultRequest;
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/discount/manage/banner",
        headersRequest
      );
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return resultRequest.data.data;
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
  };

  const generateStatusTagDiscount = (status) => {
    return (
      <>
        <span
          className={`badge  ${
            status === statusDiscount.typeGroupPublisher.DISABLE
              ? "badge-danger"
              : ""
          }  ${
            status === statusDiscount.typeGroupPublisher.ENABLE
              ? "badge-success"
              : ""
          } 
            `}
        >
          {statusDiscount.getTypeGroupPublisherPersianName()[status]}
        </span>
      </>
    );
  };

  const changeStatusDiscount = async (discountID, status) => {
    const result = window.confirm("آیا مطمئن هستید؟");
    if (!result) {
      return;
    }
    const resultSendRequestGetAllDiscounts =
      await sendRequestChangeStatusDiscount(discountID, status);
    if (resultSendRequestGetAllDiscounts) {
      await getAllDiscounts();
    }
  };

  const sendRequestChangeStatusDiscount = async (discountID, status) => {
    let headersRequest = getHeaderForRequest();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/discount/manage/banner/enable/" +
          discountID,
        {
          status: status + "",
        },
        headersRequest
      );
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return true;
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
  };

  const generateDiscountTable = () => {
    if (discounts.length === 0) {
      return;
    }

    return (
      <div className="table-responsive">
        <table className="table table-bordered table-dark tbl-td-white-space table-hover m-0">
          <thead>
            <th>#</th>
            <th>شماره کد تخفیف</th>
            <th>عنوان تخفیف</th>
            <th>تعداد استفاده</th>
            <th>تاریخ درج</th>
            <th>وضعیت</th>
            <th>عملیات</th>
          </thead>
          <tbody>
            {discounts.map((discount, index) => {
              const status = +discount.active;
              return (
                <tr key={discount._id}>
                  <td>{helpersNumbers.toPersianNum(index + 1)}</td>
                  <td>{helpersNumbers.toPersianNum(discount._id)}</td>
                  <td>{discount.title}</td>
                  <td>{helpersNumbers.toPersianNum(discount.count_use)}</td>
                  <td dir="ltr">
                    {helpersNumbers.toPersianNum(
                      helpersTime.convertGregorianToJalali(
                        discount.created_at
                      ) +
                        " " +
                        moment(discount.created_at).local().format("HH:mm:ss")
                    )}
                  </td>
                  <td>{generateStatusTagDiscount(status)}</td>
                  <td>
                    <span>
                      <span
                        className={` btn 
                      ${
                        status === statusDiscount.typeGroupPublisher.ENABLE
                          ? "btn-danger"
                          : ""
                      }
                        ${
                          status === statusDiscount.typeGroupPublisher.DISABLE
                            ? "btn-primary"
                            : ""
                        }`}
                        title={status === 1 ? "غیرفعال کردن" : "فعال کردن"}
                        onClick={(e) => {
                          changeStatusDiscount(discount._id, +!discount.active);
                        }}
                      >
                        <i
                          className={` 
          ${
            status === statusDiscount.typeGroupPublisher.ENABLE
              ? "fa fa-power-off"
              : ""
          }
            ${
              status === statusDiscount.typeGroupPublisher.DISABLE
                ? "fas fa-play"
                : ""
            }

            `}
                        ></i>
                      </span>
                      <span className="px-2">
                        <Link
                          to={
                            "/manage/discount/campaign-banner/view/" +
                            discount._id
                          }
                          className="btn btn-info"
                        >
                          <i className="fa fa-info"></i>
                        </Link>
                      </span>
                      <span>
                        <Link
                          to={
                            "/manage/discount/campaign-banner/edit/" +
                            discount._id
                          }
                          className="btn btn-success"
                        >
                          <i className="fa fa-edit"></i>
                        </Link>
                      </span>
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>
      <Sidebar />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  لیست کد های تخفیف به کمپین بنری
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div class="alert alert-info">
                <span class="pl-2">
                  <i class="fa fa-bell"></i>
                </span>
                <span>
                  تا حد امکان از ویرایش کد تخفیف خودداری کنید.بجای ویرایش کد
                  تخفیف , کد تخفیف را غیرفعال کنید و کد تخفیف جدید بسازید.
                </span>
              </div>
              <Link
                className="btn btn-primary"
                to={`/manage/discount/campaign-banner/add`}
              >
                <span className="pl-2">
                  <i class="fas fa-plus"></i>
                </span>
                <span>اضافه کردن کد تخفیف</span>
              </Link>
              <div className="py-2">{generateDiscountTable()}</div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
export default AllDiscount;
